import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

/**
 * Standalone full-page signed-out state. Renders without AppShell so the
 * sidebar/topbar aren't visible to an unauthenticated visitor.
 */
export function SignedOut() {
  const authUrl = import.meta.env.VITE_AUTH_APP_URL ?? "http://localhost:5174";
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="h-8 w-8 rounded-md border border-foreground/80 flex items-center justify-center">
              <span className="text-[15px] font-semibold leading-none">B</span>
            </div>
            <span className="font-semibold tracking-tight">Booqly</span>
          </div>
          <CardTitle>Sign in to continue</CardTitle>
          <CardDescription>
            The operator dashboard requires a signed-in workspace user. Sign in via auth.booqly.co
            and you'll be redirected back here.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <a href={`${authUrl}/sign-in`}>Open sign-in</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
